import React from 'react';
import KP_LOGO from '../images/skin/logo.png'
import TEIKYO_LOGO from '../images/skin/teikyo/logo.svg'

// バージョン情報
export const VersionName = "IstReserve SignageView ver 1.0.2";
// サービス名称
export const ServiceName = "IstReserve";

//UniversityCodeEnum
export const universityCodeEnum = {
    KANSAIGAIDAI: "kgu",
    OTHERS: "teikyo",
    DAIKOUDAI: 'daikoudai',
    TEIKYO: "teikyo",
};
/***
 * カスタムscssの取得用コードの追加
 */
export const getUniversityCustomScssCodeFromDomain = () => {
    const hostname = window.location.hostname;
    switch (hostname) {
        case "tko.ist-reserve.space":
        case "awstaging-ist-v3-tko.staging.siba-service.jp":
            return universityCodeEnum.TEIKYO;
        case "kgu.ist-reserve.space":
            return universityCodeEnum.KANSAIGAIDAI;
        case "oit.ki.siba.services":
        case "localhost":
            return universityCodeEnum.DAIKOUDAI;
        default:
            return universityCodeEnum.OTHERS;
    }
}

//大学名
export const TENANT_KEY = getUniversityCustomScssCodeFromDomain();



export const Logo = TENANT_KEY === "teikyo" ? TEIKYO_LOGO : KP_LOGO;



// WEBPACK FOOTER //
// ./src/constants/GlobalConfig.js